const content: { [key: string]: any } = {
  title: {
    pageTitle: "Who's Close",
    pageDescription:
      "This report shows a list of ABOs in your group who are within 10% of reaching their next performance bonus level.",
  },
  export: {
    button: "Export",
    title: "Export Report",
    description:
      "This Report will include a list of ABOs in your group who are within 10% of reaching their next performance bonus level.",
    exportTypeLabel: "Who's Close",
  },
  filter: {
    groupLeader: {
      allOption: "All ABOs",
    },
  },
  table: {
    segmentTitle: "Close to {segmentPercent}%",
    columns: {
      aboName: "ABO Name / Number",
      groupPV: "GPV",
      groupPVNeeded: "GPV Needed",
      personalPV: "PPV",
      totalABOCount: "Group Size",
      frontlines: "Frontlines",
      sponsorName: "Sponsor",
      watchlist: "Watchlist",
    },
  },
  losTreeView: "LOS Tree View",
} as const;

export default content;
